import { axios } from "src/common/utils";
import authHeader from "src/common/auth/authHeader";

const UserService = {};

UserService.getUserInfo = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_POTAL_SERVICE}/api/Users/GetUserAndVendorProfile`,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
UserService.getMenu = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/Menu/GetMenu`,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export default UserService;
